import TemplateListItem from './TemplateListItem';

export default TemplateListItem;
